<template>
  <div class="flex flex-col justify-center items-start gap-3">
    <!-- switcher: card type or list type -->
    <!-- <div class="w-full flex items-center justify-end gap-4 mb-4" v-show="isShowCardSwitcher">
      <button
        class="p-2 rounded w-10 h-10 flex items-center justify-center border-2"
        :class="[isRow ? 'bg-white border-primary text-primary' : 'bg-primary text-white']"
        @click.prevent="() => (isRow = true)"
      >
        <i class="ica-custom-fonts-dotted-list"></i>
      </button>
      <button
        class="p-2 rounded w-10 h-10 flex items-center justify-center border-2"
        :class="[!isRow ? 'bg-white border-primary text-primary' : 'bg-primary text-white']"
        @click.prevent="() => (isRow = false)"
      >
        <i class="ica-custom-fonts-menu-view"></i>
      </button>
    </div> -->
    <input
      :placeholder="t('startwriteServiceName')"
      type="text"
      class="w-full ps-3 py-1.5 rounded-sm border border-brand-grayblue-300 outline-none focus:border-primary read-only:bg-brand-gray-250 placeholder:normal-case"
      v-model="searchValue"
    />
    <div
      v-if="viewAs == 'grid'"
      class="w-full h-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2"
    >
      <template :key="key" v-for="(service, key) in pageContent">
        <ServiceCardVue
          :label="service.localizedServiceName"
          :serviceId="service.transactionId"
          :service-slug="service.subCategoryServiceConfig?.key"
        >
          <template #serviceCard>
            <slot name="gridCardCorner" :service="service"></slot>
          </template>
          <template #start-service>
            <slot name="gridCardActionsS" :service="service"></slot>
          </template>

          <template #applicationTracking>
            <slot name="gridCardActionsE" :service="service"></slot>
          </template>
        </ServiceCardVue>
      </template>
      <!-- <div v-for="(service, index) in pageContent" :key="index" class="w-full">
        <FavourtieCard
          :title="service.localizedServiceName"
          :region="service?.selectedAdministrativeRegion"
          :isCardType="!isRow"
          :prefixBtn="$t('serviceStart')"
          :suffixBtn="$t('serviceCard')"
          icon="ica-custom-fonts-passport-stamp"
          @onPrefixClick="onPrefixClick(service)"
          @onSuffixClick="onSuffixClick(service)"
        />
      </div> -->
    </div>
    <div class="w-full search-content text-xs" v-else>
      <div
        :key="key"
        v-for="(item, key) in pageContent"
        class="flex flex-col lg:flex-row lg:justify-between lg:items-start gap-2 p-2 min-h-[50px] odd:bg-brand-gray-150 px-2"
      >
        <p :class="titleClass">
          <span
            class="font-mono tracking-tight text-brand-black-autofill text-xs pointer-events-none select-none"
          >
            [{{ item.transactionId }}]
          </span>
          {{ item.localizedServiceName }}
        </p>

        <slot name="extraCol"> </slot>

        <div class="flex gap-x-3 justify-end lg:justify-between">
          <slot name="rowActions" :service="item"></slot>
        </div>
      </div>
    </div>

    <div v-if="filteredContent.length > 0" class="mt-4 w-full flex justify-center">
      <Paginate
        :page-count="paginatorConfig.pageCount"
        :page-range="3"
        :click-handler="onPageClick"
        :prev-text="'‹'"
        :next-text="'›'"
        :first-last-button="true"
        container-class="pagination"
        first-button-text="«"
        last-button-text="»"
      >
      </Paginate>
    </div>
  </div>
</template>

<script setup>
import ServiceCardVue from '@/components/cards/ServiceCard.vue'
import { useDashboardStore } from '@/stores/dashboard'
import Fuse from 'fuse.js'
import { computed, nextTick, onMounted, reactive, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import Paginate from 'vuejs-paginate-next'

import { useRouter } from 'vue-router'

const dashboardStore = useDashboardStore()
const router = useRouter()

const props = defineProps({
  searchCategoryId: {
    type: String,
    required: true
  },
  services: Array,
  // isShowCardSwitcher: {
  //   type: Boolean,
  //   default: () => false
  // },
  pageLength: {
    type: Number,
    default: () => 8
  },
  // CardType: have two type(card and list)
  isCardType: {
    type: Boolean,
    default: () => false
  },
  titleClass: {
    type: String,
    default: () => 'line-clamp-3 break-words text-primary text-xs max-w-max lg:max-w-[38rem]'
  },
  viewAs: {
    type: String,
    default: () => 'list' // or grid
  }
})

const { t } = useI18n()

const searchValue = ref('')

const fuse = ref()
const isRow = ref(false)

const paginatorConfig = reactive({
  totalItemCount: 0,
  itemsPerPage: 5,
  currentPage: 1,
  pageCount: 0
})

const resetSearch = async () => {
  await nextTick()
  paginatorConfig.totalItemCount = filteredContent.value || 0
  paginatorConfig.pageCount = Math.ceil((filteredContent.value?.length || 1) / props.pageLength)
}

watch(
  () => searchValue.value,
  async () => {
    await resetSearch()
  }
)

onMounted(async () => {
  await resetSearch()
  fuse.value = new Fuse(props.services, {
    includeScore: true,
    threshold: 0.2,
    keys: ['localizedServiceName', 'serviceDescription', 'serviceFullDescription', 'transactionId']
  })
})

const pageContent = computed(() => {
  if (!props.services) return []

  const startIndex = (paginatorConfig.currentPage - 1) * props.pageLength
  const endIndex = Math.min(startIndex + props.pageLength, props.services.length)

  return filteredContent.value.slice(startIndex, endIndex)
})

const filteredContent = computed(() => {
  if (!props.services || !searchValue.value) return props.services
  return fuse.value.search(searchValue.value).map((fc) => fc.item)
})

const onPageClick = (pageNum) => {
  paginatorConfig.currentPage = pageNum
}

dashboardStore.$subscribe((mutation, state) => {
  if (mutation.type != 'patch function') return
  searchValue.value = state.filterAsSearchText
})

const onPrefixClick = (item) => {
  router.push({
    name: 'ServiceForm',
    params: { serviceId: item?.transactionId, withException: false },
    query: {
      moduleId: item?.moduleId,
      adminRegionId: item?.adminRegionId
    }
  })
}

const onSuffixClick = (item) => {
  router.push({
    name: 'FavServiceCard',
    query: {
      serviceTransactionId: item?.transactionId,
      administrativeRegionId: item?.adminRegionId
    }
  })
}
</script>

<script>
export default {
  name: 'ServiceDirectory'
}
</script>

<style lang="scss"></style>
